import { Navigate } from "react-router-dom";
import useAuth from "./useAuth";

const SecureRoute = ({ children }) => {
    const { loggedIn, checkLoggedIn } = useAuth()

    const logStatus = (loggedIn === true ? loggedIn : checkLoggedIn());
    console.log("Secure route executing: [" + logStatus + "]");

    if (!logStatus) {
        return <Navigate to="/login" />
    }

    return children;
}

export default SecureRoute
